import { ClientReporter } from './ClientReporter';

const reporters = new Map<string, ClientReporter>();

function getPrefixByOpType(opType: string): string {
  // 前缀格式：client_report_{opType}，例如：client_report_sorting_scan / client_report_pickup_arrival_scan
  return `client_report_${opType}`;
}

export function getClientReporter(opType: string): ClientReporter {
  const normalized = String(opType || '').trim();
  if (!normalized) {
    throw new Error('[ClientReport] opType is required');
  }
  const existing = reporters.get(normalized);
  if (existing) return existing;

  const reporter = new ClientReporter(normalized, getPrefixByOpType(normalized));
  reporters.set(normalized, reporter);
  return reporter;
}

